import { ReactElement } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { ResultsView } from './views/ResultsView';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';

type TResultsProps = {
  configs?: {
    resultsSportType?: string;
  };
};

const resultsDefaultConfigs = {
  resultsSportType: undefined
};

const resultsDefaultProps = {
  configs: resultsDefaultConfigs
};

const resultsPrefix = SpringConfigs.PAGE_URLS.results
  ? SpringConfigs.PAGE_URLS.results
      .replace(window.location.origin, '')
      .replace('/', '')
  : window.location.pathname.split('/')[1];

export const Results = ({
  configs = resultsDefaultConfigs
}: TResultsProps = resultsDefaultProps): ReactElement => {
  const history = useHistory();
  const { path: _path } = useSbRouteMatch(history.location.pathname);

  const pageUrl = _path.includes(resultsPrefix)
    ? `${_path.split(resultsPrefix)[0]}${resultsPrefix}`
    : '/';

  return (
    <Switch>
      <Route
        path={`${pageUrl.length > 1 ? `${pageUrl}/` : pageUrl}`}
        render={() => <ResultsView configs={configs} />}
      />
    </Switch>
  );
};
